import React, { useContext } from 'react';
import './RenewalDetails.scss';
import SectionMessage from './SectionMessage.jsx';
import InstructionDetails from './InstructionDetails.jsx';
import { getRolloverRateForProduct } from '../../../utils/renewalHelpers';
import { formatProductTerm } from "../../../utils/helpers";
import {customerDataContext} from "../../../contexts/CustomerDataProvider";

/** @import {RenewalDetailsProps} from './RenewalDetailsTypes' */

function RenewalDetails(/** @type {RenewalDetailsProps} */ {account, instruction, linkedAccounts}) {
    const data = useContext(customerDataContext);
    const product = data?.data?.customer.products.find(product => product.id === instruction?.options?.rolloverAccountProductId);
    const availableRolloverRate = getRolloverRateForProduct(product, account);
    const formattedAvailableRolloverRate = typeof availableRolloverRate === 'number' ? availableRolloverRate.toFixed(2) : '0.00';
    const displayNewToBankRate = product ? product.rate > availableRolloverRate : false;
    const rate = displayNewToBankRate ? product?.rate : availableRolloverRate.toFixed(2);
    const term = formatProductTerm(product?.productTerm);
    
    return (
        <div className={'confirmTableContainer'}>
            <div className={'detailsWrapper'}>
                <InstructionDetails
                    account={account}
                    instruction={instruction}
                    linkedAccounts={linkedAccounts}
                    rate={formattedAvailableRolloverRate}
                    term={term}
                />
                
            </div>
            <SectionMessage account={account} />
        </div>
    );
}

export default RenewalDetails;